export interface PickupDetails { name: string; phone: string }
export interface SavedPickupDetails extends PickupDetails { version: 1; savedAt: number }
export const PICKUP_RETENTION_MS = 90 * 24 * 60 * 60 * 1000;

export function pickupProfileKey(mode: string, identity?: string): string {
  return `tequisa-pickup-profile-${JSON.stringify([mode, identity ?? 'guest'])}`;
}

/** Accept Indonesian mobile numbers or an explicit international country code. */
export function normalizePickupPhone(value: string): string | null {
  if (!value.trim()) return '';
  if (!/^[+\d\s().-]+$/.test(value) || value.length > 40) return null;
  let phone = value.replace(/[\s().-]/g, '');
  if (phone.startsWith('08')) phone = `+62${phone.slice(1)}`;
  else if (phone.startsWith('62')) phone = `+${phone}`;
  return /^\+[1-9]\d{7,14}$/.test(phone) ? phone : null;
}

export function readPickupProfile(key: string, now = Date.now()): SavedPickupDetails | null {
  try {
    const saved = JSON.parse(localStorage.getItem(key) ?? 'null');
    if (saved?.version !== 1 || typeof saved.name !== 'string' || !saved.name.trim() || saved.name.length > 80 ||
      typeof saved.phone !== 'string' || normalizePickupPhone(saved.phone) !== saved.phone ||
      !Number.isFinite(saved.savedAt) || saved.savedAt > now) return null;
    if (now - saved.savedAt >= PICKUP_RETENTION_MS) { localStorage.removeItem(key); return null; }
    return { version: 1, name: saved.name, phone: saved.phone, savedAt: saved.savedAt };
  } catch { return null; }
}

export function savePickupProfile(key: string, details: PickupDetails): SavedPickupDetails {
  const phone = normalizePickupPhone(details.phone);
  if (!details.name.trim() || details.name.trim().length > 80) throw new Error('name');
  if (phone === null) throw new Error('phone');
  const saved: SavedPickupDetails = { version: 1, name: details.name.trim(), phone, savedAt: Date.now() };
  localStorage.setItem(key, JSON.stringify(saved));
  return saved;
}
